import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class DatapointService {
  constructor(private http: HttpClient) {}

  public getDataSetGroups() {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint + "/dataset/groups?count=50&orderBy=name"
    );
  }
  public getDataPoints(datasets?: any) {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/datapoints?count=20000&orderBy=name&dataSets=" +
        datasets
    );
  }

  public searchDataFields(
    searchterm: string,
    count: number,
    page: number
  ): any {
    return this.http.get(
      environment.enterpriseUrls.apiEndpoint +
        "/datapoints/search?count=" +
        count +
        "&page=" +
        page +
        "&searchTerm=" +
        searchterm
    );
  }
}
